export default "__VITE_ASSET__BJ_aAzZ0__"